<section class="container" aria-labelledby="client-career-heading">
	<lvr-heading>
		{{ 'client.career.title' | transloco }} {{ client()?.name
		}}{{ client()?.firstName ? ', ' + client()?.firstName : '' }}
		@if (client()?.dateOfBirth) {
			*{{ client()?.dateOfBirth | date: dateDisplayFormat }}
		}
	</lvr-heading>

	@if (canCreateCareer()) {
		<lvr-button
			variant="primary"
			[label]="'client.career.career' | transloco"
			[ariaLabel]="'client.career.create' | transloco"
			[type]="'button'"
			(clicked)="openCreate()"
			icon="add"
		></lvr-button>
	}

	@defer {
		@if (latestCareer()) {
			<lvr-accordion>
				<div class="career-link-wrapper">
					<lvr-accordion-item [expanded]="true" [toggleOnIconOnly]="true" style="margin-top: 32px">
						<div
							ngProjectAs="accordion-header"
							class="accordion-header-inner link latest-career-header"
							[routerLink]="[latestCareer().id]"
						>
							<span class="latest-career-date">{{ latestCareer().startOfCareerStage | date: 'dd.MM.yyyy' }}</span>
							<span class="latest-career-label">{{ latestCareer().socialSecurityStatus.remark }}</span>
						</div>
						@let data = occupationData(latestCareer());
						@if (data.institutionName && !data.isSchool) {
							<p class="occupation-topline" lvrPadding [padHorizontal]="16" [padVertical]="0">
								<span>{{ 'client.career.occupationWithInstitution' | transloco }}:</span>
								@if (getInstitutionRoute(latestCareer()); as route) {
									<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
										{{ data.institutionName }}&nbsp;→
									</a>
								} @else {
									<span>{{ data.institutionName }}&nbsp;→</span>
								}
							</p>
						} @else if (data.title && !data.institutionName && !data.isSchool) {
							<p lvrPadding [padHorizontal]="16" [padVertical]="0">
								{{ 'client.career.occupation_title_description' | transloco: data }}
							</p>
						} @else if (data.isSchool && data.institutionName) {
							<p lvrPadding [padHorizontal]="16" [padVertical]="0">
								{{ 'client.career.occupation_school_description_prefix' | transloco }}&nbsp;
								@if (getInstitutionRoute(latestCareer()); as route) {
									<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
										{{ data.institutionName }}&nbsp;→{{
											'client.career.occupation_school_description_suffix' | transloco
										}}
									</a>
								} @else {
									<span
										>{{ data.institutionName
										}}{{ 'client.career.occupation_school_description_suffix' | transloco }}</span
									>
								}
							</p>
						}
						<table>
							<tr>
								<th>{{ 'client.career.typeAndScopeOfTheWorkplace' | transloco }}</th>
								<th>{{ 'client.career.person' | transloco }}</th>
								@if (isInstitutionInformedVisible(latestCareer())) {
									<th>{{ 'client.career.institutionInformedLabel' | transloco }}</th>
								}
							</tr>
							<tr>
								<td class="truncate-cell" [attr.title]="getTypeAndScope(latestCareer())">
									<span class="truncate-text">{{ getTypeAndScope(latestCareer()) }}</span>
								</td>
								<td class="truncate-cell" [attr.title]="getPersonNameOfWorkplaceJob(latestCareer())">
									<span class="truncate-text">
										@if (getPersonRoute(latestCareer()); as route) {
											<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
												{{ getPersonNameOfWorkplaceJob(latestCareer()) }}&nbsp;→
											</a>
										} @else {
											{{ getPersonNameOfWorkplaceJob(latestCareer()) }}
										}
									</span>
								</td>
								@if (isInstitutionInformedVisible(latestCareer())) {
									<td class="truncate-cell" [attr.title]="getInstitutionInformedKey(latestCareer()) | transloco">
										<span class="truncate-text">{{ getInstitutionInformedKey(latestCareer()) | transloco }}</span>
									</td>
								}
							</tr>
						</table>
					</lvr-accordion-item>
				</div>
			</lvr-accordion>
		}
		@if (pastCareers().length > 0) {
			<lvr-accordion>
				@for (item of pastCareers(); track item.id) {
					<div class="career-link-wrapper">
						<lvr-accordion-item [expanded]="true" [toggleOnIconOnly]="true">
							<div
								ngProjectAs="accordion-header"
								class="accordion-header-inner link latest-career-header"
								[routerLink]="[item.id]"
							>
								<span class="latest-career-date">{{ item.startOfCareerStage | date: 'dd.MM.yyyy' }}</span>
								<span class="latest-career-label">{{ item.socialSecurityStatus.remark }}</span>
							</div>
							@let data = occupationData(item);
							@if (data.institutionName && !data.isSchool) {
								<p class="occupation-topline" lvrPadding [padHorizontal]="16" [padVertical]="0">
									<span>{{ 'client.career.occupationWithInstitution' | transloco }}:</span>
									@if (getInstitutionRoute(item); as route) {
										<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
											{{ data.institutionName }}&nbsp;→
										</a>
									} @else {
										<span>{{ data.institutionName }}&nbsp;→</span>
									}
								</p>
							} @else if (data.title && !data.institutionName && !data.isSchool) {
								<p lvrPadding [padHorizontal]="16" [padVertical]="0">
									{{ 'client.career.occupation_title_description' | transloco: data }}
								</p>
							} @else if (data.isSchool && data.institutionName) {
								<p lvrPadding [padHorizontal]="16" [padVertical]="0">
									{{ 'client.career.occupation_school_description_prefix' | transloco }}&nbsp;
									@if (getInstitutionRoute(item); as route) {
										<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
											{{ data.institutionName }}&nbsp;→{{
												'client.career.occupation_school_description_suffix' | transloco
											}}
										</a>
									} @else {
										<span
											>{{ data.institutionName
											}}{{ 'client.career.occupation_school_description_suffix' | transloco }}</span
										>
									}
								</p>
							}
							<table>
								<tr>
									<th>{{ 'client.career.typeAndScopeOfTheWorkplace' | transloco }}</th>
									<th>{{ 'client.career.person' | transloco }}</th>
									@if (isInstitutionInformedVisible(item)) {
										<th>{{ 'client.career.institutionInformedLabel' | transloco }}</th>
									}
								</tr>
								<tr>
									<td class="truncate-cell" [attr.title]="getTypeAndScope(item)">
										<span class="truncate-text">{{ getTypeAndScope(item) }}</span>
									</td>
									<td class="truncate-cell" [attr.title]="getPersonNameOfWorkplaceJob(item)">
										<span class="truncate-text">
											@if (getPersonRoute(item); as route) {
												<a class="btn-link" [routerLink]="route" (click)="$event.stopPropagation()">
													{{ getPersonNameOfWorkplaceJob(item) }}&nbsp;→
												</a>
											} @else {
												{{ getPersonNameOfWorkplaceJob(item) }}
											}
										</span>
									</td>
									@if (isInstitutionInformedVisible(item)) {
										<td class="truncate-cell" [attr.title]="getInstitutionInformedKey(item) | transloco">
											<span class="truncate-text">{{ getInstitutionInformedKey(item) | transloco }}</span>
										</td>
									}
								</tr>
							</table>
						</lvr-accordion-item>
					</div>
				}
			</lvr-accordion>
		}
	}
</section>
